/**
 * GrcLayout — shell partagé du module GRC & Communication.
 *
 * Jumeau de ScolaireLayout / ServiceTechniqueLayout, accent « grc ». Garantit
 * que l'en-tête (AppHeader) et la barre d'onglets (GrcNav) restent affichés sur
 * TOUTES les pages du module, comme pour les autres briques — au lieu de laisser
 * chaque page GRC gérer (ou oublier) son propre header.
 */

import { type ReactNode } from 'react';
import { AppHeader } from '@/components/AppHeader';
import { GrcNav, type GrcNavKey } from '@/components/GrcNav';

export function GrcLayout({
  active,
  children,
}: {
  active: GrcNavKey;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen text-ink">
      <AppHeader module="GRC & communication" accent="grc" />

      <nav
        aria-label="Sections GRC"
        className="sticky top-[57px] z-50 border-b border-border bg-surface/60 backdrop-blur-glass"
      >
        {/* Pas d'overflow-x-auto ici : il créerait un contexte de scroll qui
            CLIPPE verticalement le menu déroulant « Dossiers ». Les onglets
            passent à la ligne sur petit écran (flex-wrap géré dans GrcNav). */}
        <div className="px-4 py-2 sm:px-6">
          <GrcNav active={active} />
        </div>
      </nav>

      {children}
    </div>
  );
}
